import { create } from "zustand";
import type { RecordingSink } from "@hybrid-iptv/recorder";

/**
 * "Record now" from the guide, on the website (Section 15 recording started
 * from Section 20's Record buttons).
 *
 * The guide cannot record by itself: the recorder captures the player's video.
 * So the guide asks for the save location while it still has the click (a
 * browser only opens its file picker from a user gesture), tunes the channel,
 * and leaves this request; the player starts recording into that file once the
 * channel plays, and stops at the programme's end.
 */
export interface RecordRequest {
  channelId: string;
  title: string;
  /** The file the viewer picked; absent where the browser has no picker (the recording goes to browser storage). */
  sink?: RecordingSink;
  /** Stop here: the programme's end plus a little over-run. */
  stopAtMs: number;
}

interface RecordRequestStore {
  pending: RecordRequest | null;
  request: (request: RecordRequest) => void;
  take: () => RecordRequest | null;
}

export const useRecordRequest = create<RecordRequestStore>((set, get) => ({
  pending: null,
  request: (request) => set({ pending: request }),
  take: () => {
    const pending = get().pending;
    if (pending) set({ pending: null });
    return pending;
  },
}));
